import { ImageRenderer } from '~shared/ui/molecules';

import { FallbackPrivateChatImage } from './fallback';
import type { TChatImageProps } from './types';

export const PrivateChatImage: React.FC<
	TChatImageProps & { showPreview?: boolean; showLoader?: boolean }
> = ({
	width,
	height,
	media,
	fallbackUrl,
	quality,
	onClick,
	showPreview = false,
	showLoader = true,
}) => {
	if (media && media.length > 0) {
		return (
			<ImageRenderer
				onClick={onClick}
				item={media}
				alt=""
				quality={quality}
				showLoader={showLoader}
				showPreview={showPreview}
				width={width}
				height={height}
				fallback={fallbackUrl}
			/>
		);
	} else if (fallbackUrl) {
		return (
			<FallbackPrivateChatImage
				width={width}
				height={height}
				quality={quality}
				fallbackUrl={fallbackUrl}
				onClick={onClick}
			/>
		);
	}
	return null;
};
